import React from "react";

export const useLink = (slug) => {
    if (!slug && slug !== '') return null
    else if (slug === '/') return ''
    if (slug[slug.length - 1] === '/') return slug
    else return `${slug}/`
}